import axios, { AxiosResponse } from 'axios';
import {Response, ApiResponse} from '../../interface/IResponse';


async function getTotalNumberOfLoansFunction(): Promise<AxiosResponse<ApiResponse<number>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Dashboard/getTotalNumberOfLoans";

        const response: AxiosResponse<ApiResponse<number>> = await axios.get<ApiResponse<number>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getTotalNumberOfIncomingDueDatesFunction(): Promise<AxiosResponse<ApiResponse<number>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Dashboard/getTotalNumberOfIncomingDueDates";

        const response: AxiosResponse<ApiResponse<number>> = await axios.get<ApiResponse<number>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}


async function getTotalNumberOfMembersFunction(): Promise<AxiosResponse<ApiResponse<number>>> {

    try
    {
        var apiUrl = process.env.REACT_APP_API_URL + "/Dashboard/getTotalNumberOfMembers";

        const response: AxiosResponse<ApiResponse<number>> = await axios.get<ApiResponse<number>>(apiUrl, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }); 

        return response;

    }
    catch(error){
        if(axios.isAxiosError(error)){
           
           throw error.response?.data.message;

        }
        else{
            throw error;
        }
   }
}

const dashboardService = {
    getTotalNumberOfLoans : getTotalNumberOfLoansFunction,
    getTotalNumberOfIncomingDueDates : getTotalNumberOfIncomingDueDatesFunction,
    getTotalNumberOfMembers : getTotalNumberOfMembersFunction
}



export default dashboardService;